module.exports = __webpack_public_path__ + "img/mood-icon-3.f5ef40f8.svg";